export default __webpack_public_path__ + "static/media/button_hamburger.52223e71.png";